import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const AverageAttendanceRedux = createActions({
  AverageAttendanceExcelRequest: [''],
  AverageAttendanceExcelSuccess: [''],
  AverageAttendanceExcelError: ['error'],
},
{
  prefix: 'AVERAGE_ATTENDANCE_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = AverageAttendanceRedux
export const AverageAttendanceTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const AverageAttendanceExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const AverageAttendanceExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const AverageAttendanceExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.AverageAttendanceExcelRequest]: AverageAttendanceExcelRequest,
  [Types.AverageAttendanceExcelSuccess]: AverageAttendanceExcelSuccess,
  [Types.AverageAttendanceExcelError]: AverageAttendanceExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/AverageAttendanceRedux.js